export enum CardSingleActionType {
  ResetPin = 'ResetPin',
  SpendControls = 'SpendControls',
  LockCard = 'LockCard',
  UnlockCard = 'UnlockCard',
  CloseCard = 'CloseCard',
  ReportLost = 'ReportLost',
  EditCardName = 'EditCardName',
}
